import axios from 'axios';
import uuid from 'uuid/v4';
var PlaceSearchAPI = (function () {
    function PlaceSearchAPI(config, country) {
        if (country === void 0) { country = 'de'; }
        this.config = config;
        this.country = country;
        this.sessionToken = uuid();
    }
    PlaceSearchAPI.getInstance = function (config, country) {
        if (!PlaceSearchAPI.instance) {
            PlaceSearchAPI.instance = new PlaceSearchAPI(config, country);
        }
        return PlaceSearchAPI.instance;
    };
    PlaceSearchAPI.prototype.fetchAutoCompletions = function (address) {
        return axios
            .get(new URL('/postalcodes/search', this.config.api.endpoint).toString(), {
            params: { address: address, sessionToken: this.sessionToken, country: this.country },
        })
            .then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    PlaceSearchAPI.prototype.fetchPlaceDetails = function (placeId, placeName) {
        return axios
            .get(new URL('/postalcodes/find', this.config.api.endpoint).toString(), {
            params: { placeId: placeId, placeName: placeName, sessionToken: this.sessionToken, country: this.country },
        })
            .then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    PlaceSearchAPI.prototype.getInputValue = function (_a) {
        var city = _a.city;
        return city ? "" + city : '';
    };
    return PlaceSearchAPI;
}());
export default PlaceSearchAPI;
//# sourceMappingURL=api.js.map